/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgPenitentiaryFill = "fr-icon-ssg-penitentiary-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgPenitentiaryLine = "fr-icon-ssg-penitentiary-line";
export var ssgIconsBuilding = [iconSsgPenitentiaryFill, iconSsgPenitentiaryLine];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgMergeFill = "fr-icon-ssg-merge-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgMergeLine = "fr-icon-ssg-merge-line";
export var ssgIconsDocument = [iconSsgMergeFill, iconSsgMergeLine];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgRenameFill = "fr-icon-ssg-rename-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgRenameLine = "fr-icon-ssg-rename-line";
export var ssgIconsEditor = [iconSsgRenameFill, iconSsgRenameLine];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgDeskAjFill = "fr-icon-ssg-desk-aj-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgDeskAjLine = "fr-icon-ssg-desk-aj-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgDeskAvFill = "fr-icon-ssg-desk-av-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgDeskAvLine = "fr-icon-ssg-desk-av-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgDocumentsBoxAjFill = "fr-icon-ssg-documents-box-aj-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgDocumentsBoxAjLine = "fr-icon-ssg-documents-box-aj-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgDocumentsBoxAvFill = "fr-icon-ssg-documents-box-av-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgDocumentsBoxAvLine = "fr-icon-ssg-documents-box-av-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgHandAjFill = "fr-icon-ssg-hand-aj-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgHandAjLine = "fr-icon-ssg-hand-aj-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgHandAvFill = "fr-icon-ssg-hand-av-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgHandAvLine = "fr-icon-ssg-hand-av-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgJusticePointFill = "fr-icon-ssg-justice-point-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgJusticePointLine = "fr-icon-ssg-justice-point-line";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgJusticeStickmanFill = "fr-icon-ssg-justice-stickman-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgJusticeStickmanLine = "fr-icon-ssg-justice-stickman-line";
export var ssgIconsJustice = [
    iconSsgDeskAjFill,
    iconSsgDeskAjLine,
    iconSsgDeskAvFill,
    iconSsgDeskAvLine,
    iconSsgDocumentsBoxAjFill,
    iconSsgDocumentsBoxAjLine,
    iconSsgDocumentsBoxAvFill,
    iconSsgDocumentsBoxAvLine,
    iconSsgHandAjFill,
    iconSsgHandAjLine,
    iconSsgHandAvFill,
    iconSsgHandAvLine,
    iconSsgJusticePointFill,
    iconSsgJusticePointLine,
    iconSsgJusticeStickmanFill,
    iconSsgJusticeStickmanLine,
];
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgLocationCrossFill = "fr-icon-ssg-location-cross-fill";
/**
 * @deprecated sera supprimé dans une future Release d'ici fin 2025. Importer les icones depuis : @design-system-etat/dsfr-commun
 */
export var iconSsgLocationCrossLine = "fr-icon-ssg-location-cross-line";
export var ssgIconsMap = [iconSsgLocationCrossFill, iconSsgLocationCrossLine];
